import { render, staticRenderFns } from "./UserBform.vue?vue&type=template&id=03dab953&scoped=true&"
import script from "./UserBform.vue?vue&type=script&lang=js&"
export * from "./UserBform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dab953",
  null
  
)

export default component.exports